
































import Component from "vue-class-component";
import { Vue } from "vue-property-decorator";
import { selectMenuKey as filePathKey } from "@/custom/page/filemanager/FileManagerPage.vue";
import { currentPath as userPathKey } from "@/custom/page/useradmin/UserAdministrationPage.vue";

@Component
export default class MenuPage extends Vue {
  get hasAdminRole() {
    let account = this.$store.getters.account;
    return account.authorities.includes('ROLE_ADMIN');
  }

  goToUserAdministrationPage() {
    localStorage.setItem(userPathKey, '1');
    this.$router.push({ name: 'PermissionListPage' });
  }

  goToProjectListPage() {
    localStorage.setItem(filePathKey, '1');
    this.$router.push({ name: 'ProjectListPage' });
  }

  goToGeodeticViewer() {
    localStorage.setItem(filePathKey, '1');
    this.$router.push({ name: 'GeodeticViewer' });
  }
}
